import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { initCheckout } from '@/api/checkout/checkoutApi';
import { CheckoutForm } from '@/features/checkout/components/CheckoutForm';
import { paymentSearchSchema } from '@/features/checkout/payment.schema';
import { QueryKeys } from '@/lib/constants/query-keys';
import { queryClient } from '@/lib/queryClient';
import { requireAuthenticated } from '@/permissions';

import '@/routes/pagamento/pagamento.scss';

export const Route = createFileRoute('/pagamento/')({
  staticData: { title: 'Pagamento' },
  beforeLoad: requireAuthenticated(),
  validateSearch: (search: Record<string, unknown>) => paymentSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ pacoteId: search.pacoteId!, cupom: search.cupom }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData({
      queryKey: [QueryKeys.INICIA_PAGAMENTO, deps],
      queryFn: () => initCheckout(deps),
    }),
  component: PaymentRoute,
});

function PaymentRoute(): JSX.Element {
  const { pacoteId, cupom } = Route.useSearch();
  const loaderData = Route.useLoaderData();

  if (!pacoteId) {
    return <></>;
  }

  return (
    <CheckoutForm
      pacoteId={pacoteId}
      cupom={cupom}
      loaderData={loaderData}
    />
  );
}
